module.exports = __webpack_public_path__ + "static/media/cactus.1c30e698.svg";